import { RoutesConst } from "../routeConstant";
// /profile
var mainProfileURL = "".concat(RoutesConst.ROOT).concat(RoutesConst.PROFILE);
/** Урлы роутов для профиля пользователя */
export var RoutesListProfile = {
    /** Профиль юзера */
    getUserProfile: function () { return mainProfileURL; },
    /** Редактирование профиля */
    getUserProfileEdit: function () { return "".concat(mainProfileURL, "/").concat(RoutesConst.EDIT); },
};
